import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type GetTrainingReportQueryVariables = Types.Exact<{
  input: Types.TrainingReportArgsInput;
}>;


export type GetTrainingReportQuery = { __typename?: 'QueryModel', training: { __typename?: 'TrainingReportQueryModel', report: { __typename?: 'ConnectionOfTrainingReportRow', token?: string | null, records: Array<{ __typename?: 'TrainingReportRow', trainingHours: string, trainingDate: string, trainingType: string, certificateImageId?: any | null, employee: { __typename?: 'Employee', firstName: string, lastName: string } }> } } };


export const GetTrainingReportDocument = gql`
    query GetTrainingReport($input: TrainingReportArgsInput!) {
  training {
    report(input: $input) {
      token
      records {
        employee {
          firstName
          lastName
        }
        trainingHours
        trainingDate
        trainingType
        certificateImageId
      }
    }
  }
}
    `;

/**
 * __useGetTrainingReportQuery__
 *
 * To run a query within a React component, call `useGetTrainingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrainingReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTrainingReportQuery(baseOptions: Apollo.QueryHookOptions<GetTrainingReportQuery, GetTrainingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrainingReportQuery, GetTrainingReportQueryVariables>(GetTrainingReportDocument, options);
      }
export function useGetTrainingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrainingReportQuery, GetTrainingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrainingReportQuery, GetTrainingReportQueryVariables>(GetTrainingReportDocument, options);
        }
export type GetTrainingReportQueryHookResult = ReturnType<typeof useGetTrainingReportQuery>;
export type GetTrainingReportLazyQueryHookResult = ReturnType<typeof useGetTrainingReportLazyQuery>;
export type GetTrainingReportQueryResult = Apollo.QueryResult<GetTrainingReportQuery, GetTrainingReportQueryVariables>;